import { IconButton, Tooltip } from '@mui/material'
import { InfoIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { corporate } from 'src/providers/globalVars'

export type TootltipInfoType = {
  title: string
  color?: string
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

type Props = {
  tooltipInfo: TootltipInfoType
}

export function TooltipInfo({ tooltipInfo }: Props): JSX.Element {
  return (
    <Tooltip
      title={tooltipInfo.title}
      placement={tooltipInfo.placement}
      componentsProps={styles}
      arrow
    >
      <IconButton
        sx={{ color: tooltipInfo.color || corporate.primaryColor, padding: 0 }}
        size="small"
      >
        <InfoIcon fontSize="small" htmlColor={corporate.primaryColor} sx={{ fontSize: 22 }} />
      </IconButton>
    </Tooltip>
  )
}
